"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADVERTISING_SLOT = exports.ADVERTISING_PLACEHOLDER_TEXT = void 0;
var ADVERTISING_PLACEHOLDER_TEXT = exports.ADVERTISING_PLACEHOLDER_TEXT = 'publicidade';
var ADVERTISING_SLOT = exports.ADVERTISING_SLOT = 'web_account_banner_top';